var app = new Vue({
  el: '#quiz-app',
  data() {
    return {
      currentQuestionIndex: 0,
      isSending: false,
      isComplete: false,
      notApplicable: false,
      answeringFor: 'Me',
      storageKey: 'quizResults',
      answers: {},
      email: '',
      quiz_marketing: ['true'],
      hasEmail: false,
      hasClass: false,
      questions: [
        {
          id: 'Is_this_product_for_you_or_your_partner',
          title: 'Are you shopping for yourself or your partner?',
          inputName: 'Is_this_product_for_you_or_your_partner',
          type: 'tiles',
          answers: ['Yourself', 'Partner']
        },
        {
          id: 'Have_you_ever_struggled_to_gain_or_maintain_an_erection',
          title: 'Have you ever struggled to perform in the bedroom?',
          inputName: 'Have_you_ever_struggled_to_gain_or_maintain_an_erection',
          type: 'tiles',
          answers: ['Yes', 'No'],
          filterQuestionFor: 'Me',
        },
        {
          id: 'Has_your_partner_ever_struggled_to_gain_or_maintain_an_erection',
          title: 'Has your partner ever struggled to perform in the bedroom?',
          inputName: 'Has_your_partner_ever_struggled_to_gain_or_maintain_an_erection',
          type: 'tiles',
          answers: ['Yes', 'No'],
          filterQuestionFor: 'Partner',
        },
        {
          id: 'How_often_do_you_experience_erectile_difficulties',
          title: 'How often have you experienced this?',
          inputName: 'How_often_do_you_experience_erectile_difficulties',
          type: 'tiles',
          answers: ['Frequently', 'Occasionally'],
          filterQuestionFor: 'Me',
        },
        {
          id: 'How_often_do_they_experience_erectile_difficulties',
          title: 'How often have you experienced this?',
          inputName: 'How_often_do_they_experience_erectile_difficulties',
          type: 'tiles',
          answers: ['Frequently', 'Occasionally'],
          filterQuestionFor: 'Partner'
        },
        {
          id: 'Have_you_been_struggling_with_this_for_longer_than_one_year',
          title: 'Did you first experience this over one year ago?',
          inputName: 'Have_you_been_struggling_with_this_for_longer_than_one_year',
          type: 'tiles',
          answers: ['Yes', 'No', 'Unsure'],
          filterQuestionFor: 'Me',
        },
        {
          id: 'Has_your_partner_been_struggling_with_this_for_longer_than_one_year',
          title: 'Did your partner first experience this over one year ago?',
          inputName: 'Has_your_partner_been_struggling_with_this_for_longer_than_one_year',
          type: 'tiles',
          answers: ['Yes', 'No', 'Unsure'],
          filterQuestionFor: 'Partner',
        },
        {
          id: 'Do_you_feel_the_symptoms_are_worse_than_one_year_ago',
          title: 'Do you feel your performance was better in the past?',
          inputName: 'Do_you_feel_the_symptoms_are_worse_than_one_year_ago',
          type: 'tiles',
          answers: ['Yes', 'No', 'Unsure'],
          filterQuestionFor: 'Me',
        },
        {
          id: 'Do_you_feel_their_symptoms_are_worse_than_one_year_ago',
          title: 'Do you feel their performance was better in the past?',
          inputName: 'Do_you_feel_their_symptoms_are_worse_than_one_year_ago',
          type: 'tiles',
          answers: ['Yes', 'No', 'Unsure'],
          filterQuestionFor: 'Partner',
        },
        {
          id: 'Have_you_recently_had_prostate_pelvic_surgery',
          title: 'Have you recently taken blood thinners?',
          inputName: 'Have_you_recently_had_prostate_pelvic_surgery',
          type: 'tiles',
          answers: ['Yes', 'No'],
          filterQuestionFor: 'Me',
        },
        {
          id: 'Have_they_recently_had_prostate_pelvic_surgery',
          title: 'Have they recently taken blood thinners?',
          inputName: 'Have_they_recently_had_prostate_pelvic_surgery',
          type: 'tiles',
          answers: ['Yes', 'No'],
          filterQuestionFor: 'Partner',
        },
        {
          id: 'Have_you_previously_used_aids',
          title: 'Have you ever taken a PDE-5 (like sildenafil or tadalafil)?',
          inputName: 'Have_you_previously_used_aids',
          type: 'tiles',
          answers: ['Yes', 'No'],
          filterQuestionFor: 'Me',
        },
        {
          id: 'Have_they_previously_used_aids',
          title: 'Have they ever taken a PDE-5 (like sildenafil or tadalafil)?',
          inputName: 'Have_they_previously_used_aids',
          type: 'tiles',
          answers: ['Yes', 'No'],
          filterQuestionFor: 'Partner',
        },
        {
          id: 'Have_you_been_advised_by_a_physician_against_taking_ED_drugs',
          title: 'Do you exercise regularly?',
          inputName: 'Have_you_been_advised_by_a_physician_against_taking_ED_drugs',
          type: 'tiles',
          answers: ['Yes', 'No'],
          filterQuestionFor: 'Me',
        },
        {
          id: 'Has_your_partner_been_advised_by_a_physician_against_taking_ED_drugs',
          title: 'Does your partner exercise regularly?',
          inputName: 'Has_your_partner_been_advised_by_a_physician_against_taking_ED_drugs',
          type: 'tiles',
          answers: ['Yes', 'No'],
          filterQuestionFor: 'Partner',
        },
        {
          id: 'Are_your_erectile_difficulties_affecting_your_day_to_day_life',
          title: 'Would a boost in sexual performance improve your day-to-day life?',
          inputName: 'Are_your_erectile_difficulties_affecting_your_day_to_day_life',
          type: 'tiles',
          answers: ['Yes', 'No'],
          filterQuestionFor: 'Me',
        },
        {
          id: 'Are_their_erectile_difficulties_affecting_your_day_to_day_life',
          title: 'Would a boost in sexual performance improve your day-to-day life?',
          inputName: 'Are_their_erectile_difficulties_affecting_your_day_to_day_life',
          type: 'tiles',
          answers: ['Yes', 'No'],
          filterQuestionFor: 'Partner',
        },
         {
          id: "Whats_your_email-address",
          title: "Save your results for later? <span class='subTitle'>Enter your email to receive them. This is optional.</span>",
          inputName: "What-s_your_email_address",
          titleTwo: "Email me with news and offers, unsubscribe at any time.",
          inputNameTwo: "Email_me_with_news_and_offers",
          type: 'tiles',
          email: '',
          quiz_marketing: '',
          filterQuestionFor: 'Partner',
        },
        {
          id: "Whats_your_email-address",
          title: "Save your results for later? <span class='subTitle'>Enter your email to receive them. This is optional.</span>",
          inputName: "What-s_your_email_address",
          titleTwo: "Email me with news and offers, unsubscribe at any time.",
          inputNameTwo: "quiz_marketing",
          type: 'tiles',
          email: '',
          quiz_marketing: '',
          filterQuestionFor: 'Me',
        },
      ],
    }
  },
  mounted() {
    const previousResults = window.localStorage.getItem(this.storageKey) 
      ? JSON.parse(window.localStorage.getItem(this.storageKey)) 
      : null;
  
    if (previousResults && previousResults.hasOwnProperty('answers')) {
      this.answers = previousResults.answers;
      this.notApplicable = previousResults.notApplicable;
      this.isComplete = true;
      this.currentQuestionIndex = this.filteredQuestions.length + 1;
      
      // Fetch email from answers, if previously provided
      this.email = previousResults.answers['What-s_your_email_address'] 
        ? previousResults.answers['What-s_your_email_address'].value 
        : '';
      this.hasEmail = !!this.email;
    }
  }
  ,
  computed: {
    filteredQuestions() {
      return this.questions.filter((question, index) => {
        let maxQuestionIndex = 999;

        if (this.answers['Have_you_ever_struggled_to_gain_or_maintain_an_erection'] && this.answers['Have_you_ever_struggled_to_gain_or_maintain_an_erection'].value === 'No') {
          
          //--- added (Skiping the questions after 2nd question's answer is 'NO')----//
          if (question.inputName === 'How_often_do_you_experience_erectile_difficulties' || 
              question.inputName === 'Have_you_been_struggling_with_this_for_longer_than_one_year' ||
              question.inputName === 'Do_you_feel_the_symptoms_are_worse_than_one_year_ago' ||
              question.inputName === 'Have_you_recently_had_prostate_pelvic_surgery' ||
              question.inputName === 'Have_you_previously_used_aids' ||
              question.inputName === 'Have_you_been_advised_by_a_physician_against_taking_ED_drugs' ||
              question.inputName === 'Are_your_erectile_difficulties_affecting_your_day_to_day_life') {
            return false;
          }
          this.notApplicable = true;
        }

        if (this.answers['Have_you_been_struggling_with_this_for_longer_than_one_year'] && this.answers['Have_you_been_struggling_with_this_for_longer_than_one_year'].value === 'No') {
          if (question.inputName === 'Do_you_feel_the_symptoms_are_worse_than_one_year_ago') {
            return false;
          }
        }
          
        return !question.filterQuestionFor || (question.filterQuestionFor === this.answeringFor) && index < maxQuestionIndex
      });
    },
    currentQuestion() {
      //--- Adding Class to input field of email start---//
      var CurrentQtn = this.filteredQuestions[this.currentQuestionIndex - 1];
      if (typeof CurrentQtn !== 'undefined') {
        if (CurrentQtn.id == 'Whats_your_email-address') {
          console.log("email block");
          this.hasClass = true;
        }
      }
      //--- Adding Class to input field of email end---//
      
      return this.filteredQuestions[this.currentQuestionIndex - 1];
    },
    readyForNextStep() {
      if (this.currentQuestion) {
        return Object.keys(this.answers).includes(this.currentQuestion.inputName);
      }

      return false;
    },
    isLastStep() {
      return this.currentQuestionIndex === this.filteredQuestions.length
    },
    progressPercentageStyle() {
      return `width: ${Math.round((this.currentQuestionIndex - 1) / this.filteredQuestions.length * 100)}%`;
    }
  },
  methods: {
    selectAnswer(input, question) {
      const { value } = input;
      if (['Me', 'Partner'].includes(value)) {
        this.answeringFor = value;
      }
      this.$set(this.answers, question.inputName, { value, label: question.title });
    },
    selectAnswerChkbox(input, question) {
       const { value } = input;
      
      // console.log("Checkbox state changed. Checked:", this.quiz_marketing.length);
      // console.log('input',input);
      // console.log('question',question);
      
      //this.$set(this.answers, question.inputNameTwo, { value, label: question.inputNameTwo });
    },
    async goToNextStep() {
  if (this.isLastStep) {
    document.querySelectorAll('input').forEach((input) => input.checked = false);
    this.isSending = true;
    this.currentQuestionIndex++;

    // Store answers in localStorage
    window.localStorage.setItem(this.storageKey, JSON.stringify({
      answers: this.answers,
      notApplicable: this.notApplicable,
    }));

    setTimeout(() => {
      this.isSending = false;
      this.isComplete = true;
      this.currentQuestionIndex++;
    }, 2000);
  } else {
    this.currentQuestionIndex++;
  }
},
    goToPrevStep() {
      this.currentQuestionIndex--;
    },
    resetForm() {
      this.answers = {};
      this.currentQuestionIndex = 1;
      this.isComplete = false;
      this.notApplicable = false;
      this.email = '';
      this.hasEmail = false;
      this.quiz_marketing = []; 
      window.localStorage.removeItem(this.storageKey);
    },
    async submitEmail() {
      if (this.email) {
        this.isSending = true;
        const data = new URLSearchParams();
    
        // Append all answers to the data object
        Object.keys(this.answers).forEach((answerKey) => {
          data.append(answerKey, this.answers[answerKey].value);
        });
    
        // Append email and marketing opt-in
        data.append('What-s_your_email_address', this.email);
        data.append('quiz_marketing', this.quiz_marketing.length ? 'true' : 'false');
    
        // Determine and append recommended product result
        const recomendedProd = this.notApplicable ? 'VaxAid Trainer' : 'VaxAid Deluxe';
        data.append('result', recomendedProd);
    
        try {
          const result = await fetch('https://hub.bathmatedirect.com/sandbox/bathmate-klaviyo/response_handler.php', {
            method: 'POST',
            body: data,
          });
    
          this.hasEmail = true; // Set hasEmail to true after successful submission
          await this.$nextTick();
        } catch (error) {
          console.error('Error sending email:', error);
        } finally {
          this.isSending = false;
        }
      }
    }
    
  },
  delimiters: ['${', '}'],
})